import { render, staticRenderFns } from "./BaseCollapsibleSwitchForm.vue?vue&type=template&id=70989bf8&scoped=true"
import script from "./BaseCollapsibleSwitchForm.vue?vue&type=script&lang=js"
export * from "./BaseCollapsibleSwitchForm.vue?vue&type=script&lang=js"
import style0 from "./BaseCollapsibleSwitchForm.vue?vue&type=style&index=0&id=70989bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70989bf8",
  null
  
)

export default component.exports